import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams
} from "react-router-dom";
import ConnectABDM from "../../components/ConnectABDM/ConnectABDM";
import {
  ArrowIcon,
  CloseIcon,
  HistoryIcon,
  SearchIcon
} from "../../front-end-global-components/assets/assets";
import FeatureFlagsFallback from "../../front-end-global-components/components/FeatureFlagsFallback/FeatureFlagsFallback";
import Header from "../../front-end-global-components/components/Header/Header";
import RoundedProfilePicture from "../../front-end-global-components/components/RoundedProfilePicture/RoundedProfilePicture";
import { dateAndTimeConverter } from "../../front-end-global-components/utils/constants";
import { isValidArray, isValidObject } from "../../utils/validators";
import {
  clearClinicSearchResults,
  searchAbdmClinic,
  setSearchHistory
} from "../../redux/abdm/actions";
import InputBox from "../../front-end-global-components/components/InputBox/InputBox";
import Select from "../../front-end-global-components/components/Select/Select";
import { AbdmConsentHealthInfoTypes } from "../../utils/constants";
import Button from "../../front-end-global-components/components/Button/Button";
import {
  createAutoApprove,
  disableAutoApprove,
  enableAutoApprove,
  setAuthModes,
  setTransactionId
} from "../../redux/patients/actions";
import { matchPath } from "react-router-dom";
import { SearchImage } from "../../assets/icons/fallback";

function AutoApproval(props) {
  const [searchKey, setSearchKey] = useState({
    current: "",
    previous: ""
  });

  const navigate = useNavigate();
  const location = useLocation();

  return (
    <>
      <Header
        hideSupport={true}
        title={
          location.pathname === "/settings/autoApproval/create/search"
            ? "Search Clinic"
            : matchPath(
                "/settings/autoApproval/create/:facilityId",
                location.pathname
              )
            ? "New Auto-approvals"
            : "Auto-approvals"
        }
        backButtonOnClick={() => {
          const { pathname } = location;

          if (pathname === "/settings/autoApproval/create/search") {
            navigate("/settings");
            return;
          }

          if (pathname === "/settings/autoApproval/create/search") {
            navigate("/settings/autoApproval");
            return;
          }

          if (pathname.includes("/settings/autoApproval/view/")) {
            navigate(-1);
            return;
          }

          if (pathname.includes("/settings/autoApproval/create/")) {
            navigate("/settings/autoApproval/create/search");
            return;
          }

          navigate(-1);
        }}
        headerSuffixElement={
          (location.pathname === "/settings/autoApproval" ||
            !(
              isValidObject(props.patients?.autoApprovalPolicies) &&
              Object.values(props.patients?.autoApprovalPolicies)
            )) && (
            <div
              onClick={() => {
                navigate("/settings/autoApproval/create/search");
              }}
              className="display-flex flex-align-items-center background-color-white padding-left-default padding-right-default border-radius-default cursor-pointer"
            >
              <div
                style={{
                  fontSize: "28px"
                }}
              >
                +
              </div>
              <div
                style={{
                  fontSize: "14px"
                }}
                className="padding-left-default"
              >
                Create New
              </div>
            </div>
          )
        }
      />

      {props.app.featureFlags?.healthData ? (
        <Routes>
          <Route
            index
            element={
              <div
                style={{ height: "calc(100% - 64px)" }}
                className="padding-larger overflow-scroll hide-scroll-bar"
              >
                {isValidObject(props.patients?.autoApprovalPolicies) &&
                Object.values(props.patients?.autoApprovalPolicies)?.filter(
                  (d) => d.patient.patientId === props.patients?.currentProfile
                ).length > 0 ? (
                  Object.values(props.patients?.autoApprovalPolicies)
                    ?.filter(
                      (d) =>
                        d.patient.patientId === props.patients?.currentProfile
                    )
                    ?.map((d, i) => (
                      <div key={i}>
                        <Card
                          data={d}
                          onCardClick={() => {
                            navigate(
                              `/settings/autoApproval/view/${d.documentId}`
                            );
                          }}
                        />
                      </div>
                    ))
                ) : (
                  <div className="display-flex flex-justify-content-center flex-align-items-center inherit-parent-height">
                    <FallBack
                      title="No auto-approvals yet"
                      description={
                        <div>
                          <div className="text-align-center padding-top-large">
                            Create auto-approvals by searching the
                            clinics/hospitals
                          </div>
                          <div className="text-align-center padding-top-large">
                            <Button
                              type="button"
                              text="Create New"
                              boxShadow={false}
                              onClick={() => {
                                navigate(
                                  "/settings/autoApproval/create/search"
                                );
                              }}
                            />
                          </div>
                        </div>
                      }
                    />
                  </div>
                )}
              </div>
            }
          />

          <Route
            path="/create/search"
            element={
              <div
                style={{
                  height: "calc(100% - 64px)"
                }}
                className="padding-larger overflow-hidden"
              >
                <ClinicSearch
                  searchKey={searchKey}
                  setSearchKey={setSearchKey}
                  patients={props.patients}
                  app={props.app}
                  abdm={props.abdm}
                />
              </div>
            }
          />

          <Route
            path="/create/:facilityId"
            element={
              <div
                style={{
                  height: "calc(100% - 64px)"
                }}
                className="padding-larger overflow-hidden"
              >
                <Create patients={props.patients} abdm={props.abdm} />
              </div>
            }
          />

          <Route
            path="/view/:autoApprovalId"
            element={
              <div
                style={{
                  height: "calc(100% - 64px)"
                }}
                className="padding-larger overflow-hidden"
              >
                <View patients={props.patients} abdm={props.abdm} />
              </div>
            }
          />
        </Routes>
      ) : (
        <FeatureFlagsFallback height="remaining-body-height" />
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  patients: state.patients,
  abdm: state.abdm,
  app: state.app
});

export default connect(mapStateToProps)(AutoApproval);

const Card = (props) => {
  return (
    <div onClick={props.onCardClick} className="padding-bottom-larger">
      <div className="display-flex flex-justify-content-space-between">
        <div>
          {props?.data?.data.hiu?.name ||
            props?.data?.data.hiu?.id ||
            "Undefined"}
        </div>
        <div>
          <ArrowIcon />
        </div>
      </div>
      <div className="display-flex flex-justify-content-space-between padding-top-default">
        <div className="font-size-small">ACCESS PERIOD :</div>
        <div
          style={{
            fontWeight: "bold"
          }}
          className="font-size-small"
        >
          {dateAndTimeConverter(
            +new Date(props?.data?.data?.includedSources?.[0]?.period?.from),
            "cardDateWithoutDay"
          ) || "--"}

          <span
            style={{
              fontWeight: "lighter"
            }}
          >
            {" "}
            TO{" "}
          </span>

          {dateAndTimeConverter(
            +new Date(props?.data?.data?.includedSources?.[0]?.period?.to),
            "cardDateWithoutDay"
          ) || "--"}
        </div>
      </div>
      <div className="display-flex flex-justify-content-space-between padding-top-default">
        <div className="font-size-small">POLICY EXPIRES ON :</div>
        <div
          style={{
            fontWeight: "bold"
          }}
          className="font-size-small"
        >
          {dateAndTimeConverter(
            props.data?.expiresAt?.timestamp,
            "cardDateWithoutDay"
          )}
        </div>
      </div>
    </div>
  );
};

const ClinicSearch = (props) => {
  const navigate = useNavigate();

  const [showSearchIcon, setShowSearchIcon] = useState(false);

  useEffect(() => {
    const { current, previous } = props.searchKey || {};

    setShowSearchIcon(!current || current !== previous);
    // eslint-disable-next-line
  }, [props.searchKey?.current, props.searchKey?.previous]);

  return (
    <div className="inherit-parent-height">
      <div className="position-relative inherit-parent-width margin-right-large">
        <input
          className="font-color-secondary font-size-medium padding-medium border-radius-default inherit-parent-width font-family-gilroy-regular background-white border-1px-e5e5e5"
          type="text"
          name="search clinic or hospital"
          value={props.searchKey?.current}
          onChange={(event) => {
            props.setSearchKey((prev) => ({
              ...prev,
              current: event.target.value
            }));
          }}
          autoComplete="new_data"
          placeholder="Search"
        />
        <div
          className="position-absolute right-1px top-50-percentage transform-translateY-minus-50-percentage margin-right-medium"
          data-cy={showSearchIcon ? "searchIcon" : "closeIcon"}
          onClick={() => {
            if (showSearchIcon === false) {
              clearClinicSearchResults();
              return props.setSearchKey({
                previous: "",
                current: ""
              });
            }
            if (showSearchIcon === true && props.searchKey?.current) {
              searchAbdmClinic?.(props.searchKey?.current);
              props.setSearchKey((prev) => ({
                ...prev,
                previous: props.searchKey?.current
              }));
            }
          }}
        >
          {showSearchIcon ? <SearchIcon /> : <CloseIcon />}
        </div>
      </div>

      {typeof props.patients.accessToken?.[props.patients?.currentProfile]
        ?.token === "string" &&
        props.abdm.loading === true &&
        [...Array(20)].map((_e, index) => (
          <div key={index}>
            <ClinicProfileCard loading={true} clinicName={""} locality={""} />
          </div>
        ))}

      {!props.abdm.loading &&
      ((isValidObject(props.abdm?.clinics?.search?.results) &&
        Object.values(props.abdm?.clinics?.search?.results)?.length > 0) ||
        props.abdm?.clinics?.search?.searchHistory?.length > 0) ? (
        <ClinicSearchResult
          connectOnClick={() => {
            setAuthModes(null);
            setTransactionId(null);
            navigate("/abdm/login");
          }}
          app={props.app}
          loading={props.abdm?.loading}
          abdmAccessToken={
            props.patients.accessToken?.[props.patients?.currentProfile]?.token
          }
          searchResults={
            isValidObject(props.abdm?.clinics?.search?.results)
              ? Object.values(props.abdm.clinics.search.results)
              : []
          }
          searchHistory={props.abdm?.clinics?.search?.searchHistory}
          clinicCardOnClick={(clinicId, type) => {
            if (!type && props.abdm?.clinics?.search?.results?.[clinicId]) {
              setSearchHistory?.({
                [clinicId]: {
                  ...props.abdm.clinics.search.results[clinicId],
                  timestamp: Date.now()
                }
              });
            }

            if (
              type &&
              props.abdm?.clinics?.search?.searchHistory?.[clinicId]
            ) {
              setSearchHistory?.({
                [clinicId]: {
                  ...props.abdm.clinics.search.searchHistory[clinicId],
                  timestamp: Date.now()
                }
              });
            }
            navigate(`/settings/autoApproval/create/${clinicId}`);
          }}
        />
      ) : (
        <div
          style={{
            height: "calc(100% - 40px)"
          }}
          className="display-flex flex-justify-content-center inherit-parent-width"
        >
          <FallBack
            title="No recent searches"
            description="Search to see clinics or hospitals here"
          />
        </div>
      )}
    </div>
  );
};

const FallBack = (props) => {
  return (
    <div className="display-flex flex-align-items-center flex-justify-content-center flex-direction-column inherit-parent-width">
      <div>
        <SearchImage />
      </div>
      <div>{props.title}</div>
      <div>{props.description}</div>
    </div>
  );
};

const Create = (props) => {
  const { facilityId } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    from: null,
    to: null,
    hiTypes: []
  });

  const [clinicDetails, setClinicDetails] = useState(null);

  useEffect(() => {
    const details =
      props.abdm?.clinics?.search?.results?.[facilityId] ??
      props.abdm?.clinics?.search?.searchHistory?.[facilityId] ??
      null;

    setClinicDetails(details);
  }, [
    facilityId,
    props.abdm?.clinics?.search?.results,
    props.abdm?.clinics?.search?.searchHistory
  ]);

  return (
    <div className="inherit-parent-height display-flex flex-direction-column flex-justify-content-space-between">
      <div>
        <div className="display-flex flex-align-items-center">
          <RoundedProfilePicture
            userType="corporate"
            src={props.logoURL}
            size="small"
          />
          <div className="padding-left-default">
            {clinicDetails?.identifier?.name || clinicDetails?.identifier?.id}
          </div>
        </div>

        {[
          {
            title: "APPROVAL FOR",
            value:
              props.patients.healthIdData?.[props.patients.currentProfile]
                ?.abhaAddress
          },
          { title: "PURPOSE OF REQUEST", value: "Self requested" }
        ].map((data, index) => (
          <div key={index}>
            <div className="padding-top-larger font-size-small">
              {data.title}
            </div>
            <div className="padding-top-default">{data.value}</div>
          </div>
        ))}

        <div className="display-flex margin-top-large padding-vertical-default">
          <InputBox
            className="inherit-parent-width border-radius-default padding-right-medium"
            label="FROM"
            size="small"
            type="date"
            value={formData.from?.split("T")[0] || ""}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                from: new Date(e.target.value).toISOString()
              }))
            }
          />

          <InputBox
            className="inherit-parent-width border-radius-default padding-left-medium"
            label="TO"
            size="small"
            type="date"
            value={formData.to?.split("T")[0] || ""}
            maxDate={
              formData.from
                ? new Date(
                    new Date(formData.from).setMonth(
                      new Date(formData.from).getMonth() + 6
                    )
                  )
                    .toISOString()
                    .split("T")[0]
                : ""
            }
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                to: new Date(e.target.value).toISOString()
              }))
            }
          />
        </div>

        <Select
          onChipAdded={(chip) => {
            setFormData((prev) => ({
              ...prev,
              hiTypes: [...chip]
            }));
          }}
          modalTitle="Choose your Health info type"
          multiSelect
          name="hiTypes"
          label="Request to access"
          labelClassName="letter-spacing-4-percentage padding-bottom-default"
          showAddOption={false}
          options={AbdmConsentHealthInfoTypes}
          chips={formData.hiTypes}
        />
      </div>
      <div>
        <Button
          text="Create auto-approval"
          variant="primary"
          type="button"
          boxShadow={false}
          disabled={
            !(isValidArray(formData.hiTypes) && formData.from && formData.to)
          }
          loading={props.patients?.loading}
          className="margin-top-default"
          onClick={() => {
            const { hiTypes, from, to } = formData;
            createAutoApprove({
              hiTypes,
              from: addCurrentTimeToISO(from, 5.5 * 60),
              to,
              requester: {
                id: clinicDetails?.identifier?.id,
                name: clinicDetails?.identifier?.name
              },
              navigate
            });
          }}
        />
      </div>
    </div>
  );
};

function addCurrentTimeToISO(isoString, offsetMinutes = 0) {
  const date = new Date(isoString);
  const now = new Date();

  date.setHours(
    now.getHours(),
    now.getMinutes(),
    now.getSeconds(),
    now.getMilliseconds()
  );

  date.setMinutes(date.getMinutes() + offsetMinutes);

  return date.toISOString();
}

const View = (props) => {
  const { autoApprovalId } = useParams();
  const navigate = useNavigate();

  const [clinicDetails, setClinicDetails] = useState(
    props.patients?.autoApprovalPolicies?.[autoApprovalId]
  );

  useEffect(() => {
    const details =
      props.patients?.autoApprovalPolicies?.[autoApprovalId] || null;

    setClinicDetails(details);
  }, [autoApprovalId, props.patients?.autoApprovalPolicies]);

  const includedSources =
    clinicDetails?.data?.includedSources?.[0] ||
    clinicDetails?.data?.policy?.includedSources?.[0];

  return (
    <div className="inherit-parent-height display-flex flex-direction-column flex-justify-content-space-between">
      <div>
        <div className="display-flex flex-align-items-center">
          <RoundedProfilePicture
            userType="corporate"
            src={props.logoURL}
            size="small"
          />
          <div>
            <div className="padding-left-default">
              {clinicDetails?.data?.hiu?.name ||
                clinicDetails?.data?.policy?.hiu?.name}
            </div>
            <div className="padding-left-default">
              {clinicDetails?.data?.hiu?.id ||
                clinicDetails?.data?.policy?.hiu?.id}
            </div>
          </div>
        </div>

        {[
          {
            title: "APPROVAL FOR",
            value:
              props.patients.healthIdData?.[props.patients.currentProfile]
                ?.abhaAddress
          },
          { title: "PURPOSE OF REQUEST", value: "Self requested" }
        ].map((data, index) => (
          <div key={index}>
            <div className="padding-top-larger font-size-small">
              {data.title}
            </div>
            <div className="padding-top-default">{data.value}</div>
          </div>
        ))}

        <div className="display-flex margin-top-large padding-vertical-default">
          <InputBox
            className="inherit-parent-width border-radius-default padding-right-medium"
            label="FROM"
            size="small"
            type="date"
            disabled={true}
            value={
              new Date(includedSources?.period?.from)
                .toISOString()
                .split("T")[0]
            }
          />

          <InputBox
            className="inherit-parent-width border-radius-default padding-left-medium"
            label="TO"
            size="small"
            type="date"
            disabled={true}
            value={
              new Date(includedSources?.period?.to).toISOString().split("T")[0]
            }
          />
        </div>

        <Select
          modalTitle="Choose your Health info type"
          multiSelect
          name="hiTypes"
          label="Request to access"
          labelClassName="letter-spacing-4-percentage padding-bottom-default"
          showAddOption={false}
          options={AbdmConsentHealthInfoTypes}
          disabled={true}
          chips={includedSources?.hiTypes}
        />
      </div>
      <section className="display-flex padding-top-larger">
        {clinicDetails?.enabled === false ? (
          <Button
            loading={props.loading}
            boxShadow={false}
            type="submit"
            variant="primary"
            text="Enable"
            className="border-1px-e5e5e5 margin-right-small"
            onClick={() => {
              enableAutoApprove({
                autoApprovalId: clinicDetails.autoApprovalId
              });
            }}
          />
        ) : (
          <Button
            loading={props.loading}
            boxShadow={false}
            type="submit"
            variant="danger"
            text="Disable"
            className="border-1px-e5e5e5 margin-right-small"
            onClick={() => {
              disableAutoApprove({
                autoApprovalId: clinicDetails.autoApprovalId
              });
            }}
          />
        )}
        <Button
          boxShadow={false}
          text="Cancel"
          variant={"secondary"}
          onClick={() => {
            navigate(-1);
          }}
          className={"font-color-secondary border-1px-e5e5e5 margin-left-small"}
        />
      </section>
    </div>
  );
};

function ClinicSearchResult(props) {
  return props.app.featureFlags?.findClinic ? (
    <div className="inherit-parent-height">
      {typeof props.abdmAccessToken !== "string" && (
        <div className="inherit-parent-height flex-justify-content-center flex-align-items-center">
          <ConnectABDM connectOnClick={props.connectOnClick} />
        </div>
      )}

      {typeof props.abdmAccessToken === "string" &&
        props.loading === false &&
        props.searchResults?.length > 0 && (
          <>
            <div className="font-size-small flex-justify-content-center position-sticky top-0 background-white padding-bottom-small padding-top-large z-index-1">
              HOSPITALS / CLINIC
            </div>
            <div
              style={{
                height: "calc(100% - 75px)"
              }}
              className="overflow-scroll hide-scroll-bar"
            >
              {props.searchResults?.map((data, index) => (
                <div key={index}>
                  <ClinicProfileCard
                    onClick={() => {
                      props.clinicCardOnClick(data?.identifier?.id);
                    }}
                    clinicName={data?.identifier?.name}
                    locality={data?.city ? data?.city : ""}
                  />
                </div>
              ))}
            </div>
          </>
        )}

      {typeof props.abdmAccessToken === "string" &&
        props.loading === false &&
        props.searchResults?.length === 0 &&
        props.searchHistory &&
        Object.values(props.searchHistory).length > 0 && (
          <>
            <div className="font-size-small flex-justify-content-center padding-top-large">
              SEARCH HISTORY
            </div>
            {props.searchHistory &&
              Object.values(props.searchHistory)
                .sort((first, second) => second.timestamp - first.timestamp)
                .map(
                  (data, index) =>
                    index < 3 && (
                      <div key={index}>
                        <ClinicProfileCard
                          onClick={() => {
                            props.clinicCardOnClick(
                              data?.identifier?.id,
                              "history"
                            );
                          }}
                          history={true}
                          clinicName={data?.identifier?.name}
                          locality={data?.city ? data?.city : ""}
                        />
                      </div>
                    )
                )}
          </>
        )}
    </div>
  ) : (
    <FeatureFlagsFallback />
  );
}

const ClinicProfileCard = (props) => {
  return (
    <React.Fragment key={props.clinicName}>
      <div
        className="display-flex margin-vertical-large"
        data-cy={props.clinicName}
      >
        <div
          className="display-flex flex-grow-1 flex-align-items-center font-color-secondary"
          onClick={props.onClick}
        >
          <RoundedProfilePicture
            userType="corporate"
            loading={props.loading}
            size="medium"
            src={props.profilePictureUrl?.[props.clinicName]}
          />
          {props.loading ? (
            <div className="inherit-parent-width flex-direction-column display-flex padding-left-medium flex-justify-content-center">
              <span className="border-radius-default shimmer padding-small width-50-percentage margin-bottom-default" />
              <span className="shimmer padding-small border-radius-default width-20-percentage" />
            </div>
          ) : (
            <div className="flex-grow-1 flex-direction-column display-flex padding-left-medium">
              <span
                className="font-size-medium font-family-gilroy-regular"
                data-cy={props.clinicName}
              >
                {props.clinicName}
              </span>
              <span
                className="font-size-small font-family-gilroy-regular text-transform-capitalize padding-top-small"
                data-cy={props.clinicName}
              >
                {props.locality}
              </span>
            </div>
          )}
          {!props.loading && !props.history && <ArrowIcon />}
          {props.history && <HistoryIcon />}
        </div>
      </div>
    </React.Fragment>
  );
};
